module.exports = __webpack_public_path__ + "static/img/200069.fe224050.png";